import { render, staticRenderFns } from "./LastPosts.vue?vue&type=template&id=3eae776e&"
import script from "./LastPosts.vue?vue&type=script&lang=js&"
export * from "./LastPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports